<template>
    <el-dialog
        title="操作记录"
        v-drag
        :visible.sync="visible"
        :before-close="close"
        class="record-dialog"
        width="670px"
    >
        <div>
            <el-table :data="tableData" border :max-height="'375px'" v-loading="loading">
                <el-table-column prop="pushSmsCode" label="推送ID" :show-overflow-tooltip="true" width="260px"></el-table-column>
                <el-table-column prop="operatorName" label="推送人" :show-overflow-tooltip="true" width="100px"></el-table-column>
                <el-table-column prop="pushStatus_" label="推送状态" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span :class="PUSH_STATUS_CLASS_NAME[scope.row.pushStatus]">{{ scope.row.pushStatus_ }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pushTime" label="推送时间" :show-overflow-tooltip="true" width="160px"></el-table-column>
            </el-table>
            <div class="page-wrapper">
                <MPage ref="page"
                    :current-page="page.pageNo"
                    :pageData="pageConfig"
                    :total="page.pageTotal"
                    @on-page-change="pageChange"
                    @on-size-change="sizeChange"
                ></MPage>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
import { searchPushRecord } from '../../../api/warehouseResourceManagement/loaderSalaryConfirm.js'
import MPage from '@/components/supplierPanel/mPage/Main.vue';

// 根据字典 SALARY_CONFIRM_PUSH_STATUS 加类名；1未推送，2已推送，3推送失败
const PUSH_STATUS_CLASS_NAME = {
    '1': 'salary-not-operate',
    '2': 'salary-operate-success',
    '3': 'salary-operate-fail',
}

export default {
    props: { },
    components: { MPage },
    data() {
        return {
            PUSH_STATUS_CLASS_NAME,
            visible: false,
            loading: false,
            dictData: {},
            tableData: [],
            page: {
                pageTotal: 0,
                pageNo: 1,
                pageSize: 10
            },
            pageConfig: {
                layout: 'total, sizes, prev, pager, next',
                pageSize: 10,
                pageSizes: [10, 30, 50]
            },
            confirmCode: null,
        }
    },
    methods: {
        async open(row) {
            this.visible = true
            this.loading = true
            await dictWithUrl('SALARY_CONFIRM_PUSH_STATUS').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data
                }
            }).catch(err => {})
            this.loading = false
            this.confirmCode = row.confirmCode
            this.loadData()
        },
        close() {
            this.confirmCode = null
            this.tableData = []
            this.page.pageNo = 1
            this.page.pageTotal = 0
            this.visible = false
        },
        loadData() {
            this.loading = true
            const params = {
                confirmCode: this.confirmCode,
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
            }
            searchPushRecord(params).then(res => {
                if (res && +res.code === 0) {
                    this.page.pageTotal = res.data.totalCount
                    this.tableData = res.data.list.map(item => {
                        item.pushStatus_ = this.dictData.SALARY_CONFIRM_PUSH_STATUS[item.pushStatus]
                        return item
                    })
                }
            }).finally(() => {
                this.loading = false
            })
        },
        pageChange(val) {
            this.page.pageNo = val
            this.loadData()
        },
        sizeChange(val) {
            this.page.pageNo = 1
            this.page.pageSize = val
            this.loadData()
        },
    },
}
</script>
<style lang="less" scoped>
.record-dialog {
    /deep/ .page-wrapper {
        margin-top: 10px;
        height: 28px;
    }

    .push-fail {
        color: #f96c5f;
    }
}
</style>